/* eslint-disable react-hooks/exhaustive-deps */
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { processDoubtConfig } from '@api/processors/custom-doubts';
import { getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';
import { useMemo } from 'react';

const useDoubtConfig = (goalUID, options = { fallbackData: undefined }) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const key = `v2/doubts/learner/config/?goal_uid=${goalUID}&is_doubts_page=true`;
  const {
    data: doubtConfigData,
    mutate,
    ...rest
  } = useFetch(
    isLoggedIn ? key : null,
    { useCamelCase: false },
    { fallbackData: options.fallbackData }
  );

  const processedDoubtConfig = useMemo(
    () =>
      doubtConfigData?.errorCode
        ? doubtConfigData
        : processDoubtConfig(doubtConfigData),
    [doubtConfigData, processDoubtConfig]
  );

  return {
    key,
    doubtConfigData: processedDoubtConfig,
    mutate,
    ...rest
  };
};

export default useDoubtConfig;
